import { FC, PropsWithChildren } from "react";
import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./styles.module.scss";

/**
 * The `InputContainerPlaceholder` component properties.
 */

export interface InputContainerPlaceholderProps extends BaseProps {

  /**
   * Indicates whether the component has instructions. If not specified defaults to `false`.
   */
  readonly hasInstructions?: boolean;
}

/**
 * Component which acts as the container for all inputs.
 */
export const InputContainerPlaceholder: FC<PropsWithChildren<InputContainerPlaceholderProps>> = (props) => {
  const { children, hasInstructions = false } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.InputContainerPlaceholder, "placeholder"],
  });

  return (
    <Stack {...getBasePropsFromHtmlProps(baseHtmlProps)} spacing="mini" alignment="span">
      <Body className={classNames(styles.PlaceholderLabel, "label")} size="mini">
        <Skeleton />
      </Body>
      {children}
      {(hasInstructions) && (
        <Body className={classNames(styles.PlaceholderInstructions, "instructions")} size="mini">
          <Skeleton />
        </Body>
      )}
    </Stack>
  );
};
